module.exports = __webpack_public_path__ + "static/media/mediaIcon.d6017113.svg";